export const SekansRightOptions = props => {
  const imagesSrc = props.rightOptionsImages

  const currentBpm = props.currentBpm
  const bpmImgSrc = imagesSrc[currentBpm]

  return (
    <div className="sekansRightOptionsContainer">
      <div className="sekansBmpDisplayContainer" id="bmpDisplayContainer">
        <img draggable="false" src={bpmImgSrc} className="sekansFullImage visible noContextMenu" alt="bpm" />
      </div>
      <div className="sekansRightOptionsRowContainer">
        <div className="sekansRightOptionContainer pointerHover" id="sekansBpmMinusContainer" data-action="changeBpm" data-type="minus" title="A">
          <img draggable="false" src={imagesSrc[5]} className="sekansFullImage visible noContextMenu" alt="bpm minus up" onClick={props.handleClick} />
          <img draggable="false" src={imagesSrc[6]} className="sekansFullImage hidden noContextMenu" alt="bpm minus down" onClick={props.handleClick} />
        </div>
        <div className="sekansRightOptionContainer pointerHover" id="sekansBpmPlusContainer" data-action="changeBpm" data-type="plus" title="S">
          <img draggable="false" src={imagesSrc[7]} className="sekansFullImage visible noContextMenu" alt="bpm plus up" onClick={props.handleClick} />
          <img draggable="false" src={imagesSrc[8]} className="sekansFullImage hidden noContextMenu" alt="bpm plus down" onClick={props.handleClick} />
        </div>
      </div>
      
      <div className="sekansPlayStopContainer pointerHover" id="sekansPlayStopContainer" data-action="playStop" title="D">
        <img draggable="false" src={imagesSrc[9]} className="sekansFullImage visible noContextMenu" alt="playStop up" onClick={props.handleClick} />
        <img draggable="false" src={imagesSrc[10]} className="sekansFullImage hidden noContextMenu" alt="playStop down" onClick={props.handleClick} />
      </div>
      
      <div className="sekansRightOptionsRowContainer">
        <div className="sekansRightOptionContainer pointerHover" id="sekansUpArrowContainer" data-action="moveCursor" data-type="up" title="Up Arrow">
          <img draggable="false" src={imagesSrc[11]} className="sekansFullImage visible noContextMenu" alt="up arrow up" onClick={props.handleClick} />
          <img draggable="false" src={imagesSrc[12]} className="sekansFullImage hidden noContextMenu" alt="up arrow down" onClick={props.handleClick} />
        </div>
        <div className="sekansRightOptionContainer pointerHover" id="sekansNftLinkContainer" data-action="nftLink" title="F">
          <img draggable="false" src={imagesSrc[13]} className="sekansFullImage visible noContextMenu" alt="nft link up" onClick={props.handleClick} />
          <img draggable="false" src={imagesSrc[14]} className="sekansFullImage hidden noContextMenu" alt="nft link down" onClick={props.handleClick} />
        </div>
      </div>
    </div>
  )
}